import { render, staticRenderFns } from "./employee-card.vue?vue&type=template&id=29ed7d24&scoped=true&lang=pug"
import script from "./employee-card.vue?vue&type=script&lang=ts"
export * from "./employee-card.vue?vue&type=script&lang=ts"
import style0 from "./employee-card.vue?vue&type=style&index=0&id=29ed7d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ed7d24",
  null
  
)

export default component.exports